var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 95,
    viewBox: "0 0 140 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 4.89893V4.89893C93.5309 4.89893 112.601 23.969 112.601 47.4998V47.4998C112.601 71.0306 93.5309 90.1007 70 90.1007V90.1007C46.4692 90.1007 27.3992 71.0306 27.3992 47.4998V47.4998C27.3992 23.969 46.4692 4.89893 70 4.89893Z",
    stroke: "#0A5190",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 49.8656V26.2026",
    stroke: "#0A5190",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9937 66.6703C69.4715 66.6703 69.05 67.0919 69.0562 67.6141C69.0562 68.1363 69.4778 68.5578 70 68.5578C70.5222 68.5578 70.9437 68.1363 70.9437 67.6141C70.9437 67.0982 70.5222 66.6703 69.9937 66.6703",
    stroke: "#0A5190",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.384 8.2207C139.863 31.4495 139.863 63.5433 122.384 86.7722",
    stroke: "#0A5190",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5716 86.7785C0.0933269 63.5497 0.0933269 31.4559 17.5716 8.22705",
    stroke: "#0A5190",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.518b8ebc3efa437663a9119d801cd30e.svg";
export { ForwardRef as ReactComponent };